import {
  LOYALTY_PROGRAM_SENDOUTS_COLOR,
  MAX_MESSENGER_COLOR,
} from '@app/constants/integrationsColors';
import {
  ATC_BEELINE,
  ATC_MANGO,
  LOYALTY_PROGRAM_SENDOUTS,
  MAX_MESSENGER,
  TELEGRAM_PERSONAL,
} from '@app/constants/socialIntegrationsTypes';
import type { NConstants } from '@app/types/Constants';

export const ICONS: NConstants.Icons = [
  {
    id: 'tag',
    code: 'fa-solid fa-tag',
    color: '#000000',
  },
  {
    id: 'money-bill',
    code: 'fa-solid fa-money-bill',
    color: '#000000',
  },
  {
    id: 'dollar-sign',
    code: 'fa-solid fa-dollar-sign',
    color: '#000000',
  },
  {
    id: 'lock-open',
    code: 'fa-solid fa-lock-open',
    color: '#000000',
  },
  {
    id: 'lock',
    code: 'fa-solid fa-lock',
    color: '#000000',
  },
  {
    id: 'comments',
    code: 'fa-solid fa-comments',
    color: '#000000',
  },
  {
    id: 'envelope',
    code: 'fa-solid fa-envelope',
    color: '#000000',
  },
  {
    id: 'phone',
    code: 'fa-solid fa-phone',
    color: '#000000',
  },
  {
    id: 'mobile-screen-button',
    code: 'fa-solid fa-mobile-screen-button',
    color: '#000000',
  },
  {
    id: 'location-dot',
    code: 'fa-solid fa-location-dot',
    color: '#000000',
  },
  {
    id: 'vk',
    code: 'fa-brands fa-vk',
    color: '#0277FF',
  },
  {
    id: 'instagram',
    code: 'fa-brands fa-instagram',
    color: '#000000',
  },
  {
    id: 'whatsapp',
    code: 'fa-brands fa-whatsapp',
    color: '#5BDE8C',
  },
  {
    id: 'viber',
    code: 'fa-brands fa-viber',
    color: '#000000',
  },
  {
    id: 'telegram',
    code: 'fa-solid fa-robot',
    color: '#3290EC',
  },
  {
    id: 'email-handler',
    code: 'fa-solid fa-at',
    color: 'rgb(2, 119, 255)',
  },
  {
    id: 'apple',
    code: 'fa-brands fa-apple',
    color: '#000000',
  },
  {
    id: 'windows',
    code: 'fa-brands fa-windows',
    color: '#000000',
  },
  {
    id: 'yandex',
    code: 'fa-brands fa-yandex',
    color: '#000000',
  },
  {
    id: 'google',
    code: 'fa-brands fa-google',
    color: '#000000',
  },
  {
    id: 'internet-explorer',
    code: 'fa-brands fa-internet-explorer',
    color: '#000000',
  },
  {
    id: 'paperclip',
    code: 'fa-solid fa-paperclip',
    color: '#000000',
  },
  {
    id: 'link',
    code: 'fa-solid fa-link',
    color: '#000000',
  },
  {
    id: 'gift',
    code: 'fa-solid fa-gift',
    color: '#000000',
  },
  {
    id: 'users',
    code: 'fa-solid fa-users',
    color: '#000000',
  },
  {
    id: 'user',
    code: 'fa-solid fa-user',
    color: '#000000',
  },
  {
    id: 'person',
    code: 'fa-solid fa-person',
    color: '#000000',
  },
  {
    id: 'person-dress',
    code: 'fa-solid fa-person-dress',
    color: '#000000',
  },
  {
    id: 'child',
    code: 'fa-solid fa-child',
    color: '#000000',
  },
  {
    id: 'thumbtack',
    code: 'fa-solid fa-thumbtack',
    color: '#000000',
  },
  {
    id: 'bookmark',
    code: 'fa-solid fa-bookmark',
    color: '#000000',
  },
  {
    id: 'box',
    code: 'fa-solid fa-box',
    color: '#000000',
  },
  {
    id: 'bolt-lightning',
    code: 'fa-solid fa-bolt-lightning',
    color: '#000000',
  },
  {
    id: 'fire',
    code: 'fa-solid fa-fire',
    color: '#000000',
  },
  {
    id: 'star',
    code: 'fa-solid fa-star',
    color: '#000000',
  },
  {
    id: 'triangle-exclamation',
    code: 'fa-solid fa-triangle-exclamation',
    color: '#000000',
  },
  {
    id: 'bomb',
    code: 'fa-solid fa-bomb',
    color: '#000000',
  },
  {
    id: 'crown',
    code: 'fa-solid fa-crown',
    color: '#000000',
  },
  {
    id: 'check',
    code: 'fa-solid fa-check',
    color: '#000000',
  },
  {
    id: 'percent',
    code: 'fa-solid fa-percent',
    color: '#000000',
  },
  {
    id: 'certificate',
    code: 'fa-solid fa-certificate',
    color: '#000000',
  },
  {
    id: 'xmark',
    code: 'fa-solid fa-xmark',
    color: '#000000',
  },
  {
    id: 'square-check',
    code: 'fa-solid fa-square-check',
    color: '#000000',
  },
  {
    id: 'heart',
    code: 'fa-solid fa-heart',
    color: '#000000',
  },
  {
    id: 'thumbs-up',
    code: 'fa-solid fa-thumbs-up',
    color: '#000000',
  },
  {
    id: 'thumbs-down',
    code: 'fa-solid fa-thumbs-down',
    color: '#000000',
  },
  {
    id: 'building-columns',
    code: 'fa-solid fa-building-columns',
    color: '#000000',
  },
  {
    id: 'mars',
    code: 'fa fa-mars',
    color: '#000000',
  },
  {
    id: 'venus',
    code: 'fa fa-venus',
    color: '#000000',
  },
  {
    id: 'clock',
    code: 'fa-solid fa-clock',
    color: '#000000',
  },
  {
    id: 'o',
    code: 'fa-solid fa-o',
    color: '#000000',
  },
  {
    id: 'file-pdf',
    code: 'fa-solid fa-file-pdf',
    color: '#000000',
  },
  {
    id: 'money-bill-wave',
    code: 'fa-solid fa-money-bill-wave',
    color: '#000000',
  },
  {
    id: 'credit-card',
    code: 'fa-regular fa-credit-card',
    color: '#000000',
  },
  {
    id: 'wallet',
    code: 'fa-solid fa-wallet',
    color: '#000000',
  },
  {
    id: 'circle',
    code: 'fa-solid fa-circle',
    color: '#000000',
  },
  {
    id: 'circle-user',
    code: 'fa-solid fa-circle-user',
    color: '#000000',
  },
  {
    id: 'square',
    code: 'fa fa-square',
    color: '#000000',
  },
  {
    id: 'search',
    code: 'fa-solid fa-magnifying-glass',
    color: '#000000',
  },
  {
    id: 'calendar',
    code: 'fa-solid fa-calendar-days',
    color: '#000000',
  },
  {
    id: 'arrows-up-down',
    code: 'fa-solid fa-arrows-up-down',
    color: '#000000',
  },
  {
    id: ATC_BEELINE,
    code: 'fa-solid fa-cloud',
    color: 'rgb(2, 119, 255)',
  },
  {
    id: ATC_MANGO,
    code: 'fa-solid fa-cloud',
    color: 'rgb(2, 119, 255)',
  },
  {
    id: TELEGRAM_PERSONAL,
    code: 'fa-brands fa-telegram',
    color: '#3290EC',
  },
  {
    id: MAX_MESSENGER,
    code: 'fa-solid fa-comment',
    color: MAX_MESSENGER_COLOR,
  },
  {
    id: LOYALTY_PROGRAM_SENDOUTS,
    code: 'fa-solid fa-percent',
    color: LOYALTY_PROGRAM_SENDOUTS_COLOR,
  },
];
